import React from 'react';
import { TabPanel } from '@one-thd/sui-atomic-components';
import QuotesCompactList from './QuotesCompactList';
import QuotesCarousel from './QuotesCarousel';
import { useQuoteContext } from '../../hooks/useQuoteContext';

const QuotesTabPanels = () => {
  const {
    activeQuotes,
    expiredQuotes,
    isMobile
  } = useQuoteContext();

  return (
    // grow, not h-full: h-full is 100% of a column the tab bar also sits in, so it overflowed by the
    // bar's height and a fixed-height card (the dashboard pairs Quotes with Projects) clipped it.
    <div className="sui-pt-3 @sm:sui-pt-4 sui-grow sui-min-h-0">
      <TabPanel
        value="active"
        index={0}
        className="sui-h-full"
      >
        {isMobile ? (
          <QuotesCompactList quotes={activeQuotes} />
        ) : (
          <QuotesCarousel quotes={activeQuotes} />
        )}
      </TabPanel>
      <TabPanel
        value="expired"
        index={1}
        className="sui-h-full"
      >
        {isMobile ? (
          <QuotesCompactList quotes={expiredQuotes} />
        ) : (
          <QuotesCarousel quotes={expiredQuotes} />
        )}
      </TabPanel>
    </div>
  );
};

export default QuotesTabPanels;
